import { useSessionStorageState } from 'ahooks'

export default function useExternals() {
  const [
    data
  , dispatch ] = useSessionStorageState(`${APP_ENV.db}:history`, { defaultValue: [] })

  const action = React.useMemo(() => {
    return {
      add: (url: string, title: string) => {
        dispatch(data => R.uniqBy(R.prop('url'), [ ...data, { url , title }]))
      },

      del: (url: string) => {
        dispatch(data => data.filter(e => e.url != url))
      },
    }
  }, [])

  return {
    data,
    dispatch,
    del: action.del,
    add: action.add,
  }
}
